import React from 'react';
import get from 'lodash/get';
import { FormattedMessage } from 'react-intl';
import Link from 'react-router/lib/Link';

import { QUESTION_TYPES } from '../../../constants/props';
import { COLORS } from '../../../constants/styles';

const consentStyle = {
  color: COLORS.flaglerDarkBlue,
};

export default ({ onLink, text, name, meta }) => {
  switch (name) {
    case QUESTION_TYPES.scale: {
      const minDescription = get(meta, 'scaleDescription.min', null);
      const maxDescription = get(meta, 'scaleDescription.max', null);
      const minValue = get(meta, 'scaleDescription.minValue');
      const maxValue = get(meta, 'scaleDescription.maxValue');

      if (!(minDescription && maxDescription)) return null;
      return (
        <div className="flex flex-column mt1 o-50">
          <div className="mb1">
            <FormattedMessage id="surveys.scale.description" />
          </div>
          <If condition={minDescription}>
            <span className="mb1">{`${minValue} - ${minDescription}`}</span>
          </If>
          <If condition={maxDescription}>
            <span>{`${maxValue} - ${maxDescription}`}</span>
          </If>
        </div>
      );
    }
    case QUESTION_TYPES.consent: {
      const consentName = get(meta, 'consentDescription.name', null);
      return (
        <Link style={consentStyle} onClick={onLink} className="mt2">
          {consentName}
        </Link>
      );
    }
    case QUESTION_TYPES.appointmentConsent: {
      return (
        <p className="mt2">
          <FormattedMessage id="surveys.appointmentConsent.accept" />
          <Link style={consentStyle} onClick={onLink} className="ml1">
            {text}
          </Link>
        </p>
      );
    }
    default:
      return null;
  }
};



// WEBPACK FOOTER //
// ./src/components/SequentialSurvey/utils/getQuestionDescription.js